// Gecici ornek kullanici (contact) listesi — Fores "Vendor Management > Users" ekranindaki
// gercek kayitlardan. Backend /api/contacts servisi gelince getContacts() gercek veriyi
// dondurur; bu fallback dataSource'taki length kontrolu ile devre disi kalir.

export interface Contact {
    ref: number;
    userName: string;
    email: string;
    firstName: string;
    lastName: string;
    // Bagli vendor (musteri) kodlari — virgulle ayrilmis. Tek alanda saklanir,
    // gridde rozet olarak gosterilir.
    vendors: string;
    userType: string;
    isActive: boolean;
    comment?: string;
    // Kullaniciya atanmis roller (Fores "Roles" sekmesi).
    roles: string[];
}

export const MOCK_CONTACTS: Contact[] = [
    { ref: 1, userName: "Abdullah.Amjad", email: "Abdullah.Amjad@akar-gmbh.de", firstName: "Abdullah", lastName: "Amjad", vendors: "10056001", userType: "Vendor User", isActive: true, roles: ["Vendor User"] },
    { ref: 2, userName: "Abdurrahman.Demirdas", email: "ademirdas@demka.de", firstName: "Abdurrahman", lastName: "Demirdas", vendors: "10001120", userType: "Vendor User", isActive: true, roles: ["Vendor User"] },
    { ref: 3, userName: "adil.caylak", email: "test@test.nl", firstName: "adil", lastName: "caylak", vendors: "10126003", userType: "Vendor User", isActive: true, roles: ["Vendor User"] },
    { ref: 4, userName: "admin.erti", email: "admin.erti@mobioffice.de", firstName: "Admin", lastName: "ErTi", vendors: "10055001", userType: "Vendor User", isActive: true, roles: ["Vendor User", "Vendor Admin"] },
    { ref: 5, userName: "Ahmet.Özcan", email: "a@mas-newgross.de", firstName: "Ahmet", lastName: "Özcan", vendors: "10109001,10229001", userType: "Vendor User", isActive: true, roles: ["Vendor User"] },
    { ref: 6, userName: "akar.admin", email: "admin@akar-gmbh.de", firstName: "Akar", lastName: "Admin", vendors: "10056001", userType: "Vendor User", isActive: true, roles: ["Vendor User", "Vendor Admin"] },
    { ref: 7, userName: "Ali.Erhan", email: "ali.erhan@akar-gmbh.de", firstName: "Ali", lastName: "Erhan", vendors: "10056001,10056011,10056012,10056013,10056014,10056018,10056019,10056020,10056021,10056050,10085002", userType: "Vendor User", isActive: true, roles: ["Vendor User", "Vendor Admin"] },
    { ref: 8, userName: "Ali.Turan", email: "aturan@ertifood.com", firstName: "Ali", lastName: "Turan", vendors: "10055001", userType: "Vendor User", isActive: true, roles: ["Vendor User"] },
    { ref: 9, userName: "Alper", email: "it@demka.de", firstName: "Alper", lastName: "Silyanov", vendors: "10001120,10234001", userType: "Vendor User", isActive: true, roles: ["Vendor User", "Vendor Admin"] },
    { ref: 10, userName: "Andreas.Schmidt", email: "a.schmidt@demka.de", firstName: "Andreas", lastName: "Schmidt", vendors: "10001120", userType: "Vendor User", isActive: true, roles: ["Vendor User"] },
];

// Verilen ref'i mock listede cozer.
export function resolveContact(ref: number | string | undefined, list: Contact[]): Contact | null {
    if (ref == null || ref === "") return null;
    const pool = list.length ? list : MOCK_CONTACTS;
    return pool.find(c => String(c.ref) === String(ref)) ?? null;
}

// Vendor kod listesini diziye cevirir ("10001,10002" -> ["10001","10002"]).
export function parseVendorCodes(vendors?: string): string[] {
    if (!vendors) return [];
    return vendors.split(",").map(v => v.trim()).filter(Boolean);
}
